import vistaProductSpecs from "./vistaDisplayProductSpecs";

export const vistaDisplayProducts = [
  {
    id: 1,
    name: "COLTEC Vista | 43 Inch Commercial Display Solutions",
    title: "43 Inch Coltec Vista Commercial Display Solutions",
    price: "35,000",
    originalPrice: "45,000",
    slug: "43-inch-coltec-vista-commercial-display-solutions",
    keywords:
      "COLTEC Vista, Commercial Display, Vista Commercial Display Solutions",
    metaDescription:
      "COLTEC Vista Commercial Display Series is built on proprietary display and processing technology, ensuring superior performance, longevity, and seamless integration. Unlike standard commercial screens, COLTEC’s proprietary image processing engine enhances color accuracy, contrast, and motion clarity for ultra-smooth visuals.",
    description:
      "COLTEC Vista Commercial Display (43-inch) Series is built on proprietary display and processing technology, ensuring superior performance, longevity, and seamless integration. Unlike standard commercial screens, COLTEC’s proprietary image processing engine enhances color accuracy, contrast, and motion clarity for ultra-smooth visuals.",
    imageUrl:
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-43.webp",
    specs: vistaProductSpecs['43"'],
    gallery: [
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-2.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-3.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-4-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-5-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-6-1.webp",
    ],
  },
  {
    id: 2,
    name: "COLTEC Vista | 55 Inch Commercial Display Solutions",
    title: "55 Inch Coltec Vista Commercial Display Solutions",
    price: "60,000",
    originalPrice: "75,000",
    slug: "55-inch-coltec-vista-commercial-display-solutions",
    keywords:
      "COLTEC Vista, Commercial Display, Vista Commercial Display Solutions",
    metaDescription:
      "COLTEC Vista Commercial Display Series is built on proprietary display and processing technology, ensuring superior performance, longevity, and seamless integration. Unlike standard commercial screens, COLTEC’s proprietary image processing engine enhances color accuracy, contrast, and motion clarity for ultra-smooth visuals.",
    description:
      "COLTEC Vista Commercial Display (55-inch) Series is built on proprietary display and processing technology, ensuring superior performance, longevity, and seamless integration. Unlike standard commercial screens, COLTEC’s proprietary image processing engine enhances color accuracy, contrast, and motion clarity for ultra-smooth visuals.",
    imageUrl:
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-55.webp",
    specs: vistaProductSpecs['55"'],
    gallery: [
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-2.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-3.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-4-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-5-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-6-1.webp",
    ],
  },
  {
    id: 3,
    name: "COLTEC Vista | 65 Inch Commercial Display Solutions",
    title: "65 Inch Coltec Vista Commercial Display Solutions",
    price: "95,000",
    originalPrice: "1,15,000",
    slug: "65-inch-coltec-vista-commercial-display-solutions",
    keywords:
      "COLTEC Vista, Commercial Display, Vista Commercial Display Solutions",
    metaDescription:
      "COLTEC Vista Commercial Display Series is built on proprietary display and processing technology, ensuring superior performance, longevity, and seamless integration. Unlike standard commercial screens, COLTEC’s proprietary image processing engine enhances color accuracy, contrast, and motion clarity for ultra-smooth visuals.",
    description:
      "COLTEC Vista Commercial Display (65-inch) Series is built on proprietary display and processing technology, ensuring superior performance, longevity, and seamless integration. Unlike standard commercial screens, COLTEC’s proprietary image processing engine enhances color accuracy, contrast, and motion clarity for ultra-smooth visuals.",
    imageUrl:
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-65.webp",
    specs: vistaProductSpecs['65"'],
    gallery: [
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-2.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-3.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-4-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-5-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-6-1.webp",
    ],
  },
  {
    id: 4,
    name: "COLTEC Vista | 75 Inch Commercial Display Solutions",
    title: "75 Inch Coltec Vista Commercial Display Solutions",
    price: "1,35,000",
    originalPrice: "1,45,000",
    slug: "75-inch-coltec-vista-commercial-display-solutions",
    keywords:
      "COLTEC Vista, Commercial Display, Vista Commercial Display Solutions",
    metaDescription:
      "COLTEC Vista Commercial Display Series is built on proprietary display and processing technology, ensuring superior performance, longevity, and seamless integration. Unlike standard commercial screens, COLTEC’s proprietary image processing engine enhances color accuracy, contrast, and motion clarity for ultra-smooth visuals.",
    description:
      "COLTEC Vista Commercial Display (75-inch) Series is built on proprietary display and processing technology, ensuring superior performance, longevity, and seamless integration. Unlike standard commercial screens, COLTEC’s proprietary image processing engine enhances color accuracy, contrast, and motion clarity for ultra-smooth visuals.",
    imageUrl:
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-75.webp",
    specs: vistaProductSpecs['75"'],
    gallery: [
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-2.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-3.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-4-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-5-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-6-1.webp",
    ],
  },
  {
    id: 5,
    name: "COLTEC Vista | 85 Inch Commercial Display Solutions",
    title: "85 Inch Coltec Vista Commercial Display Solutions",
    price: "2,00,000",
    originalPrice: "2,50,000",
    slug: "85-inch-coltec-vista-commercial-display-solutions",
    keywords:
      "COLTEC Vista, Commercial Display, Vista Commercial Display Solutions",
    metaDescription:
      "COLTEC Vista Commercial Display Series is built on proprietary display and processing technology, ensuring superior performance, longevity, and seamless integration. Unlike standard commercial screens, COLTEC’s proprietary image processing engine enhances color accuracy, contrast, and motion clarity for ultra-smooth visuals.",
    description:
      "COLTEC Vista Commercial Display (85-inch) Series is built on proprietary display and processing technology, ensuring superior performance, longevity, and seamless integration. Unlike standard commercial screens, COLTEC’s proprietary image processing engine enhances color accuracy, contrast, and motion clarity for ultra-smooth visuals.",
    imageUrl:
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-85.webp",
    specs: vistaProductSpecs['86"'],
    gallery: [
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-2.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-3.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-4-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-5-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-6-1.webp",
    ],
  },
  {
    id: 6,
    name: "COLTEC Vista | 98 Inch Commercial Display Solutions",
    title: "98 Inch Coltec Vista Commercial Display Solutions",
    price: "6,20,000",
    originalPrice: "7,00,000",
    slug: "98-inch-coltec-vista-commercial-display-solutions",
    keywords:
      "COLTEC Vista, Commercial Display, Vista Commercial Display Solutions",
    metaDescription:
      "COLTEC Vista Commercial Display Series is built on proprietary display and processing technology, ensuring superior performance, longevity, and seamless integration. Unlike standard commercial screens, COLTEC’s proprietary image processing engine enhances color accuracy, contrast, and motion clarity for ultra-smooth visuals.",
    description:
      "COLTEC Vista Commercial Display (98-inch) Series is built on proprietary display and processing technology, ensuring superior performance, longevity, and seamless integration. Unlike standard commercial screens, COLTEC’s proprietary image processing engine enhances color accuracy, contrast, and motion clarity for ultra-smooth visuals.",
    imageUrl:
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-98.webp",
    specs: vistaProductSpecs['98"'],
    gallery: [
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-2.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-3.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-4-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-5-1.webp",
      "https://content.qeeb.in/coltec/products/commercial-display/listing/vista-video-wall-listing-6-1.webp",
    ],
  },
];
